import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=a4416dce&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=a4416dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4416dce",
  null
  
)

export default component.exports